<template>
  <slot name="activator" v-bind="{ toggleShow, props: {onClick: toggleShow}}">  
    <hy-button class="modalwindowbutton" @click="toggleShow()" v-bind="$attrs" >
      <slot name="buttonText"></slot>
    </hy-button>
  </slot> 
  <ModalWindow :show="showModal" :heading="heading" :hasCloseButton="hasCloseButton" :closeOnClickOut="closeOnClickOut" :width="width" :height="height"
  @internalClose="internalClose" @open="onOpen" :class="{big}">
    <template v-slot:header><slot name="header"></slot></template>
    <template v-slot:default="{ closeWindow }">
      <slot name="modalWindowContent" :closeWindow="closeWindow"></slot>
    </template>
  </ModalWindow>
</template>

<script>

/**
 *  <ModalWindowButton>
      <template #buttonText>
        Wiedervorlage anlegen
      </template>
      <template #modalWindowContent="{ closeWindow }">
        <NewWiedervorlage @close="closeWindow"/>            <--- Componente emitiert ein close Event, welches die closeWindow-Methode aufruft. 
      </template>
    </ModalWindowButton>
 */

import {ref, watchEffect} from "vue";
import ModalWindow  from "./ModalWindow.vue"
import HyButton from "../../basic-components/HyButton.vue"

export default {
  components: {
    ModalWindow,
    HyButton
  },
  inheritAttrs: false,
  props:{
    'heading': [String, ref],
    'hasCloseButton': {
      type: Boolean,
      default: false
    },
    'closeOnClickOut': {
      type: Boolean,
      default: false
    },
    width: { type: String},
    height: { type: String },
    onOpen: Function,
    onClose: Function,
    big: Boolean,
    onBeforeCloseAsync: {
      type: Function,
      default: async () => true
    }
  },
  emits: [ "showModal"],
  setup(props, { emit }){
    let showModal = ref(false);
    watchEffect(()=>{
      emit("showModal", showModal.value);
    })

    let internalClose = async () => {
      const canClose = await props.onBeforeCloseAsync();
      
      if(canClose !== false){
        showModal.value = false;
        props.onClose?.();
      }
    }

    return {
      showModal,
      toggleShow(){
        showModal.value = !showModal.value;
      },
      internalClose
    }
  }
}
</script>

<style>
  .modalwindowbutton{
    border: 0 !important;    
    padding:0 !important;
    background: 0 !important;
    margin: 0 !important;
    cursor: pointer !important;
  }
  .modalwindowbutton:hover{
    border: 0;
    padding:0;
    background: 0 !important;
    margin: 0;
    cursor: pointer;
  }
  .modalwindowbutton:focus {
    outline:0;
  }
</style>